import {
  fetchPlateAddressesPending,
  fetchPlateAddressesSuccess,
  fetchPlateAddressesError,
} from "../redux/actions/PlateAddressAction";
import StorageApi from "../api/StorageApi";
import { Dispatch } from "redux";

export function fetchPlateAddresses(isWithLoading: boolean = true) {
  return (dispatch: Dispatch) => {
    if (isWithLoading) dispatch(fetchPlateAddressesPending());
    StorageApi.getPlateAddresses()
      .then((plateAddresses) => {
        dispatch(fetchPlateAddressesSuccess(plateAddresses));
      })
      .catch((error) => {
        console.log("error fetching PlateAddresses");
        console.log(error);
        dispatch(fetchPlateAddressesError(error));
      });
  };
}
